/**
 * V2 service-definition catalog showing management modes, license gates, and
 * supported WhiteHaX profile types independently of customer subscriptions.
 */
import { CheckCircle2 } from "lucide-react";
import { useEffect, useState } from "react";
import { listServiceDefinitions } from "./msspApi";

export default function MsspServicePlans() {
  const [plans, setPlans] = useState([]);
  useEffect(() => { listServiceDefinitions().then(setPlans); }, []);
  return (
    <section className="mssp-page">
      <div className="mssp-page-heading"><div><p className="mssp-eyebrow">Catalog</p><h1>Service definitions</h1><p>Reusable services with explicit operating modes and WhiteHaX license requirements.</p></div></div>
      <div className="mssp-plan-grid">{plans.map((plan) => <article className="mssp-panel mssp-plan" key={plan.id}><div><span className="mssp-tier">{plan.defaultCadence}</span><h2>{plan.name}</h2><p>{plan.description}</p></div><ul><li><CheckCircle2 size={17} />Modes: {plan.allowedManagementModes.map((mode) => mode.replaceAll("_", " ")).join(", ")}</li><li><CheckCircle2 size={17} />Profiles: {plan.supportedProfileTypes.join(", ")}</li><li><CheckCircle2 size={17} />Required features: {plan.requiredFeatures.join(", ")}</li></ul><small>Code: {plan.serviceCode}</small></article>)}</div>
      {/* <div className="mssp-alert info">Activating a customer service must validate these required feature keys against LICENSE.features on the backend.</div> */}
    </section>
  );
}
